/*
 * @Author: whb
 * @Date: 2022-10-09 16:47:04
 * @LastEditors: whb
 * @LastEditTime: 2023-01-10 19:32:38
 * @Description: Do not edit
 */
const keys = {
  selectRegion: 'Select Region',
  selectLang: 'Select language',
  cancel: 'Cancel',
  next: 'Next',
  back: 'Back',
  us: 'U.S.',
  usDesc: 'If you live in the United States, this Privacy Policy will apply.',
  eea: 'EEA, UK, Switzerland',
  eeaDesc: 'If you live in the European Economic Area, United Kingdom, or Switzerland, this Privacy Policy will apply.',
  otherRegion: 'Other regions',
  otherRegionDesc: 'If you live outside of the United States, European Economic Area, United Kingdom, or Switzerland, this Privacy Policy will apply.',
  forUserUs: '(For Users in US)',
  forUserEea: '(For Users in EEA, UK and Switzerland)',
  forUserOther: '(For Users in Other Regions)',
  language: 'Language',
  shortcutsTitle: 'This Privacy Policy informs you of the following information:',
  selectLangTips: 'For your better experience, we have access to a third-party translation tool to provide translation for you.',
  privacyPolicy: 'Privacy Policy',
  termsService: 'Terms of Service'
};
export default keys;
